import { render, staticRenderFns } from "./AccessoRapportiUtenzaBUModal.vue?vue&type=template&id=67a59810&"
import script from "./AccessoRapportiUtenzaBUModal.vue?vue&type=script&lang=js&"
export * from "./AccessoRapportiUtenzaBUModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AccessoRapportiUtenzaBUModal.vue"
export default component.exports